<template>
  <div>
    <Navbar />
    <transition name="fade">
      <router-view class="page" />
    </transition>

    <Footer />
    <SocialIcons />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SocialIcons from "@/components/SocialIcons";
export default {
  name: "AppLayout",
  components: { Navbar, Footer, SocialIcons },
  metaInfo: {
    title: "Property in Nepal - Find Your Dream Property",
    titleTemplate: "%s | Property in Nepal",
    meta: [
      {
        name: "description",
        content:
          "Find your dream property in Nepal. Browse through thousands of houses, apartments, and commercial properties for sale and rent across Nepal.",
      },
      {
        property: "og:site_name",
        content: "Property in Nepal",
      },
      {
        property: "og:type",
        content: "website",
      },
      {
        property: "og:url",
        content: "https://propertyinnepal.com.np",
      },
      {
        property: "og:title",
        content: "Property in Nepal - Find Your Dream Property",
      },
      {
        property: "og:description",
        content:
          "Find your dream property in Nepal. Browse through thousands of houses, apartments, and commercial properties for sale and rent across Nepal.",
      },
      {
        property: "og:image",
        content: "https://propertyinnepal.com.np/img/logo.png",
      },
      {
        property: "og:image:width",
        content: "1200",
      },
      {
        property: "og:image:height",
        content: "630",
      },
      {
        name: "twitter:card",
        content: "summary_large_image",
      },
      {
        name: "twitter:title",
        content: "Property in Nepal - Find Your Dream Property",
      },
      {
        name: "twitter:description",
        content:
          "Find your dream property in Nepal. Browse through thousands of houses, apartments, and commercial properties for sale and rent across Nepal.",
      },
      {
        name: "twitter:image",
        content: "https://propertyinnepal.com.np/img/logo.png",
      },
    ],
  },
  data: () => ({
    //
  }),
};
</script>

<style>
.page {
  max-height: 100%;
  overflow: hidden;
}
</style>
